import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "../components/style.css";
import Axios from "axios";
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';
import { FaArrowAltCircleLeft, FaUndoAlt } from "react-icons/fa";
import jwt from "jsonwebtoken";
import { thai_date, handleResizeDisplay, checkGroupsUser, getlocalStorage, formatdate } from '../function/functionALL';

require("moment/locale/th");

const ModalReFreshUpdate = ({onClose, 
    onSave, 
    show,
    setChkEmpty, 
    User_id,setUser_id}) => {
    // const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    const navigate = useNavigate();
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole

    // const [User_id, setUser_id] = useState("");
    const [loadingDataAll, setloadingDataAll] = useState(false);
    // const [loadingData_id, setloadingData_id] = useState(false);
    const handleClose = () => {
        setUser_id("");
        
        onClose();
    };

    const UpdateDataAll = (unit_id) => {
        setloadingDataAll(true);
        let timerInterval;
        Axios.post(
            process.env.REACT_APP_API_UPDATE_ALL + `${unit_id}/reload_hris/`,
            {
                headers: {
                    Authorization: "Token " + Token,
                },
            }
        )
            .then((res) => {
                Swal.fire({
                    icon: "success",
                    title: "Update สำเร็จ!",

                })
                    navigate(0);
                   
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    localStorage.removeItem("Token_");
                    localStorage.removeItem("Token");
                    navigate(
                        "/notfound404"
                        // { state: {statusCode: err.response.status, txt: err.response.data} }
                    );
                }
                console.error(err);
                Swal.fire({
                    icon: "error",
        
                  })
            });
    };


    const UpdateData_id = () => {

        if (
            User_id === ""
        ) {

            Swal.fire({
                icon: 'error',
                title: 'กรุณากรอกเลขประจำตัวประชาชน 13 หลัก'
            })
            setChkEmpty(false);
        }

        else if (User_id.length !== 13) {

            Swal.fire({
                icon: 'error',
                title: 'กรอกเลขประจำตัวประชาชนไม่ครบ 13 หลัก'
            })
            setChkEmpty(false);
        } else {
            
            const resultData_id = {
                User_id: User_id 
            }
            onSave(resultData_id, )

        }
    }

    return (
        <>
           


            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={false}
            >
                <Modal.Body>
                    <div className="rounded">
                        <div className="p-2">
                            <div className="col-sm-12 col-xs-12">
                                <div className="card-body rounded">
                                    <div className="row d-flex p-2">
                                        <div className="col-3 col-xs-12 col-sm-12 card-title text-center fs-5 w-100 fs-3" style={{ color: "#000000" }}>
                                            <div className="fw-bold" style={{ fontSize: "25px" }}>refresh / update</div>
                                        </div>
                                        <hr></hr>
                                    </div>
                                    <div className="row g-3">
                                        <div className="row col-lg-12 ms-1 p-0">
                                            <div className="row ms-0 col-12 col-lg-12 mt-2 mb-2 d-flex p-3 card-body rounded" style={{ backgroundColor: "#d0d9ff", fontSize: "14px" }}>

                                                <div className="align-items-center fw-bold text-center">สำหรับ update ข้อมูลทั้งหมด (ใช้เวลานาน*)</div>
                                                <div className="align-items-center fw-bold text-center mt-2">
                                                    {loadingDataAll ?
                                                        (<Button className="btn btn-primary col-6" style={{ fontSize: "14px", backgroundColor: "RGB(255, 181, 69,0.90)", border: 'none', width: "200px" }} >
                                                            <Spinner
                                                                as="span"
                                                                variant="light"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                                animation="border"
                                                            /> กำลัง Update ข้อมูล
                                                        </Button>) :
                                                        (<Button className="btn btn-primary col-6" style={{ fontSize: "14px", width: "200px", backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }}
                                                            onClick={() => UpdateDataAll(DataToken_.unit_id)}
                                                            disabled
                                                        // disabled={DataLogin.groups.includes("RTAFPersonAdmin") === true}
                                                        >
                                                            คลิกเพื่อ Update ข้อมูล
                                                        </Button>)}</div>


                                            </div>
                                            <div className="row ms-0 col-12 col-lg-12 mt-2 mb-2 d-flex p-3 card-body rounded" style={{ backgroundColor: "#d0d9ff", fontSize: "14px" }}>

                                                <div className="align-items-center fw-bold text-center">สำหรับ update ข้อมูลรายบุคคล</div>
                                                <div className="align-items-center fw-bold text-center mt-2 col-12" >
                                                    {/* {loading ?
                                                    (<Button className="btn btn-primary col-6" style={{ fontSize: "14px", backgroundColor: "#FFB545", border: 'none' }} >
                                                        <Spinner
                                                            as="span"
                                                            variant="light"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                            animation="border"
                                                        /> กำลัง Update ข้อมูล
                                                    </Button>) :
                                                    (<div className="col-7 d-flex align-items-center fw-bold text-center">
                                                        <input type="text" className="form-control col-xl-6 col-lg-12 col-md-12" style={{ height: "40px" }} placeholder="เลขประจำตัวประชาชน" />
                                                        <div className="col-1"></div>
                                                        <Button className="btn btn-primary col-xl-5 col-lg-11 col-md-11" style={{ fontSize: "14px" }} >
                                                            คลิกเพื่อ Update ข้อมูล
                                                        </Button>
                                                    </div>)} */}
                                                    <div className="align-items-center fw-bold text-center mt-2">
                                                        {/* {
                                                        loadingData_id ?
                                                            (<Button className="btn btn-primary col-6" style={{ fontSize: "14px", backgroundColor: "RGB(255, 181, 69,0.90)", border: 'none', width: "200px" }} >
                                                                <Spinner
                                                                    as="span"
                                                                    variant="light"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                    animation="border"
                                                                /> กำลัง Update ข้อมูล
                                                            </Button>) : */}
                                                            {/* ( */}
                                                                <div className="col-12 ">
                                                                <div className="d-flex justify-content-center text-center ">
                                                                    <input type="text" className="form-control " style={{ width: "400px" }} placeholder="เลขประจำตัวประชาชน" value={User_id} onChange={(event) => setUser_id(event.target.value)} />
                                                                </div>
                                                                <div className="d-flex justify-content-center text-center ">
                                                                    <Button className="btn btn-primary mt-2" style={{ fontSize: "14px", width: "200px", backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }}
                                                                        onClick={() => {
                                                                            UpdateData_id();
                                                                        }}>
                                                                        คลิกเพื่อ Update ข้อมูล
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                            {/* )} */}
                                                            </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">

                        <Button variant="secondary" onClick={handleClose}>
                            ปิด
                        </Button>
                    </div>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalReFreshUpdate
